import { useState } from "react";
import { useAsync } from "react-use";
import bootstrap from "../../bootstrap";
import { Loader } from "../../components/ui/PositionedSpinner";
import { ChangeApp } from "../change/change";
import { InsightProviders } from "./InsightProviders";

export const InsightBoot: React.FC = () => {
  const [appModule] = useState(() => new ChangeApp());
  const state = useAsync(async () => {
    let application = await bootstrap();
    await appModule.install();
    return application;
  }, [appModule]);

  return (
    <div className="insight-app">
      {state.loading && <Loader />}
      {state.error && <p>Error</p>}
      {!state.loading && !state.error && <InsightProviders />}
    </div>
  );
};
